import { createSelector } from 'reselect';

const selectSlideMessage = state => state.onboardingSlideMessage;

export const selectSlideMessageConfig = createSelector(selectSlideMessage, ({ config }) => config);

export const selectSlideMessageByNamespace = createSelector(
  [
    selectSlideMessage,
    (state, namespace = 'default') => namespace,
  ],
  (slideMessageReducer, namespace) => {
    const { defaults = {} } = slideMessageReducer;
    return slideMessageReducer[`namespace-${namespace}`] || defaults;
  },
);

export const makeSelectSlideMessage = () => (
  createSelector(selectSlideMessageByNamespace, ({ data }) => data || {})
);
export const makeSelectSlideMessageIsLoaded = () => (
  createSelector(selectSlideMessageByNamespace, ({ isLoaded }) => isLoaded)
);
export const makeSelectSlideMessageIsLoading = () => (
  createSelector(selectSlideMessageByNamespace, ({ isLoading }) => isLoading)
);
